/**
 * Created by mh on 2017/5/23.
 */
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Redirect, Link } from 'react-router-dom';

@observer
export default class PricingComponent extends Component {
    render() {
        // const { username, password } = this.props;
        return (
            <div className="container">
                <div className="row">
                    <div className="col-12 signin">
                        <div className="pricing-header px-3 py-3 pt-md-5 pb-md-4 mx-auto text-center">
                            <h1 className="display-4">Pricing</h1>
                            <p className="lead">
                            Start augmenting your content while using any cloud &amp; AI service. <br />
                            Connect your media assets. Automate the logic. Deliver value-added media experience. Get started now.
                            </p>
                        </div>

                        <div className="card-deck mb-3 text-center">
                            <div className="card mb-4 box-shadow">
                                <div className="card-header">
                                    <h4 className="my-0 font-weight-normal">Platform</h4>
                                </div>
                                <div className="card-body">
                                    <h1 className="card-title pricing-card-title">
                                        $19{' '}
                                        <small className="text-muted" style={{ fontSize: '14px' }}>
                                            per user, per month
                                        </small>
                                    </h1>
                                    <ul className="list-unstyled mt-3 mb-4">
                                        <li>Bring your own storage</li>
                                        <li>Meta data integration</li>
                                        <li>Email support</li>
                                        <li>Help center access</li>
                                    </ul>
                                    <Link
                                        to="/signup"
                                        className="btn btn-lg btn-block btn-outline-primary"
                                    >
                                        Sign Up
                                    </Link>
                                </div>
                            </div>
                            <div className="card mb-4 box-shadow">
                                <div className="card-header">
                                    <h4 className="my-0 font-weight-normal">engine for Windows</h4>
                                </div>
                                <div className="card-body">
                                    <h1 className="card-title pricing-card-title">
                                        <small className="text-muted" style={{ fontSize: '14px' }}>
                                            from
                                        </small>{' '}
                                        $48{' '}
                                        <small className="text-muted" style={{ fontSize: '14px' }}>
                                            / mo
                                        </small>
                                    </h1>
                                    <ul className="list-unstyled mt-3 mb-4">
                                        <li>1 workflow</li>
                                        <li>5 sub jobs</li>
                                        <li>Priority email support</li>
                                        <li>Help center access</li>
                                    </ul>
                                    <a
                                        target="_blank"
                                        href="https://smpsolutions.payrexx.com/en/pay?tid=74387af0"
                                        className="btn btn-lg btn-block btn-primary"
                                    >
                                        Get started
                                    </a>
                                </div>
                            </div>
                            <div className="card mb-4 box-shadow">
                                <div className="card-header">
                                    <h4 className="my-0 font-weight-normal">managed.radio</h4>
                                </div>
                                <div className="card-body">
                                    <h1 className="card-title pricing-card-title">
                                        <small className="text-muted" style={{ fontSize: '14px' }}>
                                            from
                                        </small>{' '}
                                        $148{' '}
                                        <small className="text-muted" style={{ fontSize: '14px' }}>
                                            / mo
                                        </small>
                                    </h1>
                                    <ul className="list-unstyled mt-3 mb-4">
                                        <li>Fully managed radio channel</li>
                                        <li>24/7 monitoring</li>
                                        <li>Phone and email support</li>
                                        <li>Help center access</li>
                                    </ul>
                                    <a
                                        target="_blank"
                                        href="https://smpsolutions.payrexx.com/en/pay?tid=74387af0"
                                        className="btn btn-lg btn-block btn-primary"
                                    >
                                        Get started
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
